import { render, staticRenderFns } from "./ModalBollettini.vue?vue&type=template&id=e4507190"
import script from "./ModalBollettini.vue?vue&type=script&lang=js"
export * from "./ModalBollettini.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports